
















































import Vue from "vue";
import { mapGetters } from "vuex";
import axios from "axios";
import { emailRules } from "../../helpers";
import { ApiUrl } from "../../config/ApiUrl";
import { getRoles } from "@/helpers";
import { LocationManager } from "@/helpers";

import FormProfile from "@/components/EditableForm/FormProfile.vue";
import RoleDescription from "@/components/atoms/RoleDescription.vue";
import * as Sentry from "@sentry/browser";

export default Vue.extend({
  data: () => ({
    valid: false,
    userDetails: {
      email: "",
      gender: "f",
      firstName: "",
      lastName: "",
      authRoleIds: [] as number[],
    },
    assignedLocations: [] as number[],
    authRoles: [],
    nameRules: [(v: any) => !!v || "Der Name ist erfoderlich"],
    emailRules: emailRules,
  }),
  components: {
    FormProfile,
    RoleDescription,
  },
  async created() {
    this.authRoles = await getRoles();
  },
  mounted() {
    if (!this.locations.length) {
      this.$store.dispatch("getLocations");
    }
  },
  watch: {
    isLocationManager: function (value) {
      if(value !== false){
        for (const location of this.locations) {
          this.assignedLocations.push(location.id as number);
        }
      }
    }
  },
  methods: {
    updateVal(val: object) {
      this.userDetails = { ...this.userDetails, ...val };
    },
    invite() {
      if (this.valid) {
        axios
          .post(ApiUrl.INVITE_USER, {
            userDetails: this.userDetails,
            url: `${window.location.origin}/#/join/{TOKEN}`,
            allowedLocationIds: this.assignedLocations,
          })
          .then((res: any) => {
            this.$toast.success("Gut gemacht! Die Einladung wurde versendet.");
            this.$router.push("/settings/user");
          })
          .catch(err => {
            this.$toast.error(
              "Das hat leider nicht geklappt. Wir arbeiten daran.."
            );
            Sentry.captureException(err);
          });
      } else {
        this.$toast.error("Bitte füllen Sie das Formular vollständig aus.");
      }
    },
  },
  computed: {
    ...mapGetters(["locations"]),
    isLocationManager(){
      return this.userDetails.authRoleIds.includes(LocationManager);
    }
  },
});
